import { SvgIconProps } from "@material-ui/core/SvgIcon";
import { makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import { memoize, omit } from "lodash";
import { forwardRef, memo, useMemo } from "react";
import { ReactComponent as arrowDown } from "../../assets/arrow-down.svg";
import { ReactComponent as addMenu } from "../../assets/generic-add-menu.svg";
import { ReactComponent as helpOutline } from "../../assets/generic-help.svg";
import { ReactComponent as userProfile } from "../../assets/generic-user-profile.svg";
import { ReactComponent as layersMenu } from "../../assets/layers.svg";
import { ReactComponent as amlFraudOverview } from "../../assets/menuIcons/aml/aml-fraud-overview.svg";
import { ReactComponent as amlFraudScreening } from "../../assets/menuIcons/aml/aml-fraud-screening.svg";
import { ReactComponent as businessAml } from "../../assets/menuIcons/aml/business-aml.svg";
import { ReactComponent as customers } from "../../assets/menuIcons/aml/customers.svg";
import { ReactComponent as individualAml } from "../../assets/menuIcons/aml/individual-aml.svg";
import { ReactComponent as kyb } from "../../assets/menuIcons/aml/kyb.svg";
import { ReactComponent as kyc } from "../../assets/menuIcons/aml/quick-kyc.svg";
import { ReactComponent as verifications } from "../../assets/menuIcons/aml/verifications.svg";
import { ReactComponent as attachment } from "../../assets/menuIcons/attachment.svg";
import { ReactComponent as blockChainTools } from "../../assets/menuIcons/blockchain/blockchain-tools.svg";
import { ReactComponent as followTheMoney } from "../../assets/menuIcons/blockchain/follow-the-money.svg";
import { ReactComponent as fraudOverview } from "../../assets/menuIcons/blockchain/fraud-overview.svg";
import { ReactComponent as reportAScam } from "../../assets/menuIcons/blockchain/report-a-fraud-scam.svg";
import { ReactComponent as wallet } from "../../assets/menuIcons/blockchain/wallet-verification.svg";
import { ReactComponent as dashboard } from "../../assets/menuIcons/dashboard.svg";
import { ReactComponent as hideEye } from "../../assets/menuIcons/hide-eye.svg";
import { ReactComponent as showEye } from "../../assets/menuIcons/show-eye.svg";
import { ReactComponent as addUser } from "../../assets/menuIcons/users/add-new-user.svg";
import { ReactComponent as listRoles } from "../../assets/menuIcons/users/list-roles.svg";
import { ReactComponent as listUsers } from "../../assets/menuIcons/users/list-users.svg";
import { ReactComponent as userManagement } from "../../assets/menuIcons/users/user-management.svg";
import { ReactComponent as addVault } from "../../assets/menuIcons/vaults/add-vault.svg";
import { ReactComponent as storeAnyData } from "../../assets/menuIcons/vaults/store-any-data.svg";
import { ReactComponent as storeCard } from "../../assets/menuIcons/vaults/store-card.svg";
import { ReactComponent as storePerson } from "../../assets/menuIcons/vaults/store-person.svg";
import { ReactComponent as vaultManagement } from "../../assets/menuIcons/vaults/vault-management.svg";
import { ReactComponent as vaultProfile } from "../../assets/menuIcons/vaults/vault-profile.svg";
import { ReactComponent as vaultMenu } from "../../assets/menuIcons/vaults/vaults.svg";
import { ReactComponent as circle } from "../../assets/users/circle.svg";

import { ReactComponent as kycApproved } from "../../assets/users/kyc/kyc-approved.svg";
import { ReactComponent as kycDeclined } from "../../assets/users/kyc/kyc-declined.svg";
import { ReactComponent as kycFailed } from "../../assets/users/kyc/kyc-failed.svg";
import { ReactComponent as kycFound } from "../../assets/users/kyc/kyc-found.svg";
import { ReactComponent as kycInReview } from "../../assets/users/kyc/kyc-in-review.svg";
import { ReactComponent as kycNotFound } from "../../assets/users/kyc/kyc-not-found.svg";
import { ReactComponent as kycNotPerformed } from "../../assets/users/kyc/kyc-not-performed.svg";
import { ReactComponent as kycNotVerified } from "../../assets/users/kyc/kyc-not-verified.svg";
import { ReactComponent as kycPending } from "../../assets/users/kyc/kyc-pending.svg";

import { ReactComponent as kycApproved_ES } from "../../assets/users/es-ES/kyc/kyc-approved.svg";
import { ReactComponent as kycDeclined_ES } from "../../assets/users/es-ES/kyc/kyc-declined.svg";
import { ReactComponent as kycFailed_ES } from "../../assets/users/es-ES/kyc/kyc-failed.svg";
import { ReactComponent as kycFound_ES } from "../../assets/users/es-ES/kyc/kyc-found.svg";
import { ReactComponent as kycInReview_ES } from "../../assets/users/es-ES/kyc/kyc-in-review.svg";
import { ReactComponent as kycNotFound_ES } from "../../assets/users/es-ES/kyc/kyc-not-found.svg";
import { ReactComponent as kycNotPerformed_ES } from "../../assets/users/es-ES/kyc/kyc-not-performed.svg";
import { ReactComponent as kycNotVerified_ES } from "../../assets/users/es-ES/kyc/kyc-not-verified.svg";
import { ReactComponent as kycPending_ES } from "../../assets/users/es-ES/kyc/kyc-pending.svg";

import { ReactComponent as kybApproved } from "../../assets/users/kyb/kyb-approved.svg";
import { ReactComponent as kybDeclined } from "../../assets/users/kyb/kyb-declined.svg";
import { ReactComponent as kybFailed } from "../../assets/users/kyb/kyb-failed.svg";
import { ReactComponent as kybFound } from "../../assets/users/kyb/kyb-found.svg";
import { ReactComponent as kybInReview } from "../../assets/users/kyb/kyb-in-review.svg";
import { ReactComponent as kybNotFound } from "../../assets/users/kyb/kyb-not-found.svg";
import { ReactComponent as kybNotPerformed } from "../../assets/users/kyb/kyb-not-performed.svg";
import { ReactComponent as kybNotVerified } from "../../assets/users/kyb/kyb-not-verified.svg";
import { ReactComponent as kybPending } from "../../assets/users/kyb/kyb-pending.svg";

import { ReactComponent as kybApproved_ES } from "../../assets/users/es-ES/kyb/kyb-approved.svg";
import { ReactComponent as kybDeclined_ES } from "../../assets/users/es-ES/kyb/kyb-declined.svg";
import { ReactComponent as kybFailed_ES } from "../../assets/users/es-ES/kyb/kyb-failed.svg";
import { ReactComponent as kybFound_ES } from "../../assets/users/es-ES/kyb/kyb-found.svg";
import { ReactComponent as kybInReview_ES } from "../../assets/users/es-ES/kyb/kyb-in-review.svg";
import { ReactComponent as kybNotFound_ES } from "../../assets/users/es-ES/kyb/kyb-not-found.svg";
import { ReactComponent as kybNotPerformed_ES } from "../../assets/users/es-ES/kyb/kyb-not-performed.svg";
import { ReactComponent as kybNotVerified_ES } from "../../assets/users/es-ES/kyb/kyb-not-verified.svg";
import { ReactComponent as kybPending_ES } from "../../assets/users/es-ES/kyb/kyb-pending.svg";

import { ReactComponent as amlApproved } from "../../assets/users/aml/aml-approved.svg";
import { ReactComponent as amlDeclined } from "../../assets/users/aml/aml-declined.svg";
import { ReactComponent as amlFailed } from "../../assets/users/aml/aml-failed.svg";
import { ReactComponent as amlFound } from "../../assets/users/aml/aml-found.svg";
import { ReactComponent as amlInReview } from "../../assets/users/aml/aml-in-review.svg";
import { ReactComponent as amlNotFound } from "../../assets/users/aml/aml-not-found.svg";
import { ReactComponent as amlNotPerformed } from "../../assets/users/aml/aml-not-performed.svg";
import { ReactComponent as amlNotVerified } from "../../assets/users/aml/aml-not-verified.svg";
import { ReactComponent as amlPending } from "../../assets/users/aml/aml-pending.svg";

import { ReactComponent as amlApproved_ES } from "../../assets/users/es-ES/aml/aml-approved.svg";
import { ReactComponent as amlDeclined_ES } from "../../assets/users/es-ES/aml/aml-declined.svg";
import { ReactComponent as amlFailed_ES } from "../../assets/users/es-ES/aml/aml-failed.svg";
import { ReactComponent as amlFound_ES } from "../../assets/users/es-ES/aml/aml-found.svg";
import { ReactComponent as amlInReview_ES } from "../../assets/users/es-ES/aml/aml-in-review.svg";
import { ReactComponent as amlNotFound_ES } from "../../assets/users/es-ES/aml/aml-not-found.svg";
import { ReactComponent as amlNotPerformed_ES } from "../../assets/users/es-ES/aml/aml-not-performed.svg";
import { ReactComponent as amlNotVerified_ES } from "../../assets/users/es-ES/aml/aml-not-verified.svg";
import { ReactComponent as amlPending_ES } from "../../assets/users/es-ES/aml/aml-pending.svg";

import { useTranslation } from "react-i18next";
import { ReactComponent as aboutUs } from "../../assets/about-us.svg";
import { ReactComponent as affiliate } from "../../assets/affiliate.svg";
import { ReactComponent as api } from "../../assets/api.svg";
import { ReactComponent as billing } from "../../assets/billing.svg";
import { ReactComponent as camera } from "../../assets/camera.svg";
import { ReactComponent as card } from "../../assets/card.svg";
import { ReactComponent as cart } from "../../assets/cart.svg";
import { ReactComponent as certificate } from "../../assets/certificate.svg";
import { ReactComponent as cog } from "../../assets/cog.svg";
import { ReactComponent as coin } from "../../assets/coin.svg";
import { ReactComponent as download } from "../../assets/download.svg";
import { ReactComponent as emailQuestion } from "../../assets/email-question.svg";
import { ReactComponent as emailTick } from "../../assets/email-tick.svg";
import { ReactComponent as email } from "../../assets/email.svg";
import { ReactComponent as empty } from "../../assets/empty.svg";
import { ReactComponent as flip } from "../../assets/flip.svg";
import { ReactComponent as followMoney } from "../../assets/follow-money.svg";
import { ReactComponent as lock } from "../../assets/lock.svg";
import { ReactComponent as marketplace } from "../../assets/marketplace.svg";
import { ReactComponent as medal } from "../../assets/medal.svg";
import { ReactComponent as amlBusinessAll } from "../../assets/menuIcons/aml-business-all.svg";
import { ReactComponent as amlBusinessNew } from "../../assets/menuIcons/aml-business-new.svg";
import { ReactComponent as amlIndividualAll } from "../../assets/menuIcons/aml-individual-all.svg";
import { ReactComponent as amlIndividualNew } from "../../assets/menuIcons/aml-individual-new.svg";
import { ReactComponent as chainAnalysisAll } from "../../assets/menuIcons/chain-analysis-all.svg";
import { ReactComponent as chainAnalysisNew } from "../../assets/menuIcons/chain-analysis-new.svg";
import { ReactComponent as cryptoToken } from "../../assets/menuIcons/crypto-token.svg";
import { ReactComponent as kybAll } from "../../assets/menuIcons/kyb-all.svg";
import { ReactComponent as kybNew } from "../../assets/menuIcons/kyb-new.svg";
import { ReactComponent as kybMenu } from "../../assets/menuIcons/kyb.svg";
import { ReactComponent as kycAll } from "../../assets/menuIcons/kyc-all.svg";
import { ReactComponent as kycNew } from "../../assets/menuIcons/kyc-new.svg";
import { ReactComponent as kycMenu } from "../../assets/menuIcons/kyc.svg";
import { ReactComponent as logout } from "../../assets/menuIcons/logout.svg";
import { ReactComponent as participations } from "../../assets/menuIcons/participations.svg";
import { ReactComponent as plus } from "../../assets/menuIcons/plus.svg";
import { ReactComponent as scamAll } from "../../assets/menuIcons/scam-all.svg";
import { ReactComponent as scamNew } from "../../assets/menuIcons/scam-new.svg";
import { ReactComponent as walletVerification } from "../../assets/menuIcons/wallet-verification.svg";
import { ReactComponent as metamaskLogo } from "../../assets/metamask-logo.svg";
import { ReactComponent as padlockClosed } from "../../assets/padlock-closed.svg";
import { ReactComponent as padlockOpen } from "../../assets/padlock-open.svg";
import { ReactComponent as privacy } from "../../assets/privacy.svg";
import { ReactComponent as rightArrow } from "../../assets/right-arrow.svg";
import { ReactComponent as rocket } from "../../assets/rocket.svg";
import { ReactComponent as staking } from "../../assets/staking.svg";
import { ReactComponent as terms } from "../../assets/terms.svg";
import { ReactComponent as tools } from "../../assets/tools.svg";
import { ReactComponent as transactions } from "../../assets/transactions.svg";
import { ReactComponent as trustswap } from "../../assets/trustswap.svg";
import { ReactComponent as usages } from "../../assets/usages.svg";
import { ReactComponent as kycApprovedShort } from "../../assets/users/kyc-approved-short.svg";
import { ReactComponent as kycFailedShort } from "../../assets/users/kyc-failed-short.svg";
import { ReactComponent as kycNotPerformedShort } from "../../assets/users/kyc-not-performed-short.svg";
import { ReactComponent as veryGoodCheck } from "../../assets/users/very-good-check.svg";
import { ReactComponent as close } from "../../assets/users/x-close.svg";
import { ReactComponent as trash } from "../../assets/vaults/closure.svg";
import { ReactComponent as copy } from "../../assets/vaults/copy-green.svg";
import { ReactComponent as exportIcon } from "../../assets/vaults/export.svg";
import { ReactComponent as whitepaper } from "../../assets/whitepaper.svg";
import { ReactComponent as upload } from "../../assets/upload.svg";
import { ReactComponent as rotate } from "../../assets/rotate.svg";
import { ReactComponent as mirror } from "../../assets/mirror.svg";
import { ReactComponent as man } from "../../assets/man.svg";
import { ReactComponent as businessman } from "../../assets/businessman.svg";

import { ReactComponent as dueDiligenceVerified } from "../../assets/users/due-diligence/verified.svg";
import { ReactComponent as dueDiligencePending } from "../../assets/users/due-diligence/pending.svg";
import { ReactComponent as dueDiligenceSubmitted } from "../../assets/users/due-diligence/submitted.svg";
import { ReactComponent as dueDiligenceProcessed } from "../../assets/users/due-diligence/processed.svg";
import { ReactComponent as dueDiligenceDeclined } from "../../assets/users/due-diligence/declined.svg";

export const iconFileMap = {
  userProfile,
  arrowDown,
  helpOutline,
  vaultMenu,
  vaultManagement,
  addVault,
  storePerson,
  storeCard,
  storeAnyData,
  layersMenu,
  addMenu,
  userManagement,
  listUsers,
  listRoles,
  addUser,
  amlFraudScreening,
  amlFraudOverview,
  kyc,
  customers,
  verifications,
  kyb,
  individualAml,
  businessAml,
  blockChainTools,
  reportAScam,
  followTheMoney,
  walletVerification,
  fraudOverview,
  copy,
  export: exportIcon,
  trash,
  veryGoodCheck,
  close,
  circle,
  hideEye,
  showEye,
  dashboard,
  vaultProfile,
  attachment,
  kycApprovedShort,
  kycFailedShort,
  kycNotPerformedShort,

  kycApproved,
  kycFailed,
  kycNotPerformed,
  kycDeclined,
  kycPending,
  kycNotFound,
  kycInReview,
  kycFound,
  kycNotVerified,

  kycApproved_ES,
  kycFailed_ES,
  kycNotPerformed_ES,
  kycDeclined_ES,
  kycPending_ES,
  kycNotFound_ES,
  kycInReview_ES,
  kycFound_ES,
  kycNotVerified_ES,

  kybApproved,
  kybFailed,
  kybNotPerformed,
  kybDeclined,
  kybPending,
  kybNotFound,
  kybInReview,
  kybFound,
  kybNotVerified,

  kybApproved_ES,
  kybFailed_ES,
  kybNotPerformed_ES,
  kybDeclined_ES,
  kybPending_ES,
  kybNotFound_ES,
  kybInReview_ES,
  kybFound_ES,
  kybNotVerified_ES,

  amlApproved,
  amlFailed,
  amlNotPerformed,
  amlDeclined,
  amlPending,
  amlNotFound,
  amlInReview,
  amlNotVerified,
  amlFound,

  amlApproved_ES,
  amlFailed_ES,
  amlNotPerformed_ES,
  amlDeclined_ES,
  amlPending_ES,
  amlNotFound_ES,
  amlInReview_ES,
  amlNotVerified_ES,
  amlFound_ES,

  logout,
  amlBusinessAll,
  amlBusinessNew,
  amlIndividualAll,
  amlIndividualNew,
  chainAnalysisAll,
  chainAnalysisNew,
  cryptoToken,
  kybAll,
  kybNew,
  kybMenu,
  kycAll,
  kycNew,
  kycMenu,
  participations,
  plus,
  scamAll,
  scamNew,
  wallet,
  api,
  followMoney,
  privacy,
  terms,
  whitepaper,
  aboutUs,
  affiliate,
  billing,
  marketplace,
  empty,
  cart,
  lock,
  card,
  padlockClosed,
  padlockOpen,
  email,
  trustswap,
  rocket,
  medal,
  upload,
  transactions,
  usages,
  metamaskLogo,
  coin,
  emailQuestion,
  emailTick,
  staking,
  camera,
  flip,
  certificate,
  cog,
  download,
  tools,
  rotateClockwise: rotate,
  rotateAnticlockwise: rotate,
  rightArrow,
  leftArrow: rightArrow,
  mirror,
  man,
  businessman,

  dueDiligenceVerified,
  dueDiligencePending,
  dueDiligenceSubmitted,
  dueDiligenceProcessed,
  dueDiligenceDeclined,
};

const ICON_SIZE = 1;

export type IconType = keyof typeof iconFileMap;

export type IconProps = SvgIconProps & {
  colour1?: string;
  colour2?: string;
  rotateAmount?: number;
  scale?: number;
  type: IconType;
  inline?: boolean;
  component?: any; // TODO: set correct typing
};

const specialIconWidth: Partial<Record<IconType, any>> = {
  dueDiligenceVerified: 91,
  dueDiligencePending: 96,
  dueDiligenceDeclined: 99,
  kybFailed: 111,
  kycFailed: 111,
  dueDiligenceSubmitted: 111,
  amlFailed: 112,
  dueDiligenceProcessed: 112,
  kycFound: 114,
  kybFound: 114,
  kycFailed_ES: 114,
  amlFound: 115,
  kybFailed_ES: 115,
  amlFailed_ES: 116,
  kycPending: 126,
  kybPending: 127,
  amlPending: 128,
  kybDeclined: 129,
  kycDeclined: 129,
  amlDeclined: 131,
  kybApproved: 135,
  kybInReview: 135,
  kycApproved: 135,
  kycInReview: 135,
  kycApproved_ES: 135,
  amlApproved: 136,
  amlInReview: 136,
  kybApproved_ES: 136,
  amlApproved_ES: 137,
  kybPending_ES: 139,
  kycPending_ES: 139,
  kycNotFound: 140,
  amlPending_ES: 140,
  kybNotFound: 141,
  amlNotFound: 142,
  kycDeclined_ES: 144,
  kybDeclined_ES: 145,
  amlDeclined_ES: 146,
  kycNotVerified: 147,
  kybNotVerified: 148,
  kybInReview_ES: 148,
  kycInReview_ES: 148,
  kycFound_ES: 148,
  amlNotVerified: 149,
  kybFound_ES: 149,
  amlInReview_ES: 149,
  amlFound_ES: 150,
  kycNotPerformed_ES: 156,
  kybNotPerformed_ES: 157,
  kybNotVerified_ES: 158,
  amlNotPerformed_ES: 158,
  kycNotVerified_ES: 158,
  amlNotVerified_ES: 159,
  kycNotPerformed: 168,
  kybNotPerformed: 169,
  kycNotFound_ES: 169,
  amlNotPerformed: 170,
  kybNotFound_ES: 170,
  amlNotFound_ES: 171,
};

const rootFn = memoize(
  ({ type, inline, rotateAmount, scale }: IconProps) => {
    const obj: Record<string, any> = {
      width: `${ICON_SIZE}em`,
      height: `${ICON_SIZE}em`,
      transition: "transform .3s ease-in-out",
    };

    if (inline) obj["display"] = "inline";
    else if (specialIconWidth[type]) {
      obj["height"] = `${ICON_SIZE * 1.7}em`;
      obj["width"] = `${(specialIconWidth[type] / 29) * ICON_SIZE * 1.7}em`;
    }

    if ("leftArrow" === type) {
      obj["transform"] = `rotate(${180 + (rotateAmount || 0)}deg) scale(${
        scale || 1
      })`;
    }

    if ("rotateClockwise" === type) {
      obj["transform"] = `scale(${scale || 1}) rotate(${
        180 + (rotateAmount || 0)
      }deg)`;
    }
    if ("rotateAnticlockwise" === type) {
      obj["transform"] = `scaleX(${-1 * (scale || 1)}) scaleY(${
        scale || 1
      }) rotate(${180 + (rotateAmount || 0)}deg)`;
    }
    return obj;
  },
  ({ type, inline, rotateAmount, scale }: IconProps) =>
    `${type}_${inline}_${rotateAmount}_${scale}`
);

const useStyles = makeStyles<IconProps, IconProps>({
  root: (p) => ({
    ...rootFn(p),
    "& .icon-primary": {
      fill: "currentColor",
    },
  }),
  onClick: {
    cursor: "pointer",
  },
  colour1: (props) => ({
    "& .icon-primary": {
      fill: props.colour1,
    },
  }),
  colour2: (props) => ({
    background: props.colour2,
    "& .icon-secondary": {
      color: props.colour2,
      fill: props.colour2,
    },
  }),
  modifier: (props) => {
    if (props.rotateAmount && props.scale) {
      return {
        transform: `rotate(${props.rotateAmount}deg) scale(${props.scale})`,
      };
    }
    if (props.rotateAmount) {
      return {
        transform: `rotate(${props.rotateAmount}deg)`,
      };
    }
    if (props.scale) {
      return {
        transform: `scale(${props.scale})`,
      };
    }
    return {};
  },
});

const langaugeIcons: Record<string, Partial<Record<IconType, IconType>>> = {
  "es-ES": {
    kycApproved: "kycApproved_ES",
    kycInReview: "kycInReview_ES",
    kycNotFound: "kycNotFound_ES",
    kycFailed: "kycFailed_ES",
    kycNotVerified: "kycNotVerified_ES",
    kycNotPerformed: "kycNotPerformed_ES",
    kycDeclined: "kycDeclined_ES",
    kycFound: "kycFound_ES",
    kycPending: "kycPending_ES",

    kybApproved: "kybApproved_ES",
    kybInReview: "kybInReview_ES",
    kybNotFound: "kybNotFound_ES",
    kybFailed: "kybFailed_ES",
    kybNotVerified: "kybNotVerified_ES",
    kybNotPerformed: "kybNotPerformed_ES",
    kybDeclined: "kybDeclined_ES",
    kybFound: "kybFound_ES",
    kybPending: "kybPending_ES",

    amlApproved: "amlApproved_ES",
    amlNotPerformed: "amlNotPerformed_ES",
    amlFailed: "amlFailed_ES",
    amlInReview: "amlInReview_ES",
    amlDeclined: "amlDeclined_ES",
    amlPending: "amlPending_ES",
    amlNotFound: "amlNotFound_ES",
    amlNotVerified: "amlNotVerified_ES",
    amlFound: "amlFound_ES",
  },
};

export const Icon = memo<IconProps>((props) => {
  const classes = useStyles(props);

  const className = useMemo(
    () =>
      classnames(props.className, classes.modifier, classes.root, {
        [classes.colour1]: props.colour1,
        [classes.colour2]: props.colour2,
        [classes.onClick]: props.onClick,
      }),
    [props.className, classes, props.colour1, props.colour2, props.onClick]
  );

  const { i18n } = useTranslation();

  // Check for icons that are specific to a language
  const type = useMemo(
    () =>
      i18n.language !== "en-GB"
        ? langaugeIcons[i18n.language]?.[props.type] || props.type
        : props.type,
    [props.type, i18n.language]
  );

  const Component = useMemo(() => iconFileMap[type], [type]);

  return (
    <Component
      className={className}
      {...omit(
        props,
        "type",
        "rotateAmount",
        "scale",
        "colour1",
        "colour2",
        "className"
      )}
    />
  );
});
